import Repository from '@/libs/axios'

const merchantResource = '/superadmin/resource'

export default {
  getMerchantListforDropdown(tenantid) {
    return Repository.get(`${merchantResource}/merchant-list?filter[tenant_id]=${tenantid}`)
  },
}
